import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { Car, Search } from 'lucide-react';

export const VehicleFinder = ({ compact = false }) => {
  const nav = useNavigate();
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [years, setYears] = useState([]);
  const [sel, setSel] = useState({ brand: '', model: '', year: '' });

  useEffect(() => {
    api.get('/vehicles/options').then(({ data }) => setBrands(data.brands || []));
  }, []);

  const pickBrand = (v) => {
    setSel({ brand: v, model: '', year: '' });
    setModels([]); setYears([]);
    api.get('/vehicles/options', { params: { brand: v } })
      .then(({ data }) => setModels(data.models || []));
  };

  const pickModel = (v) => {
    setSel((s) => ({ ...s, model: v, year: '' }));
    setYears([]);
    api.get('/vehicles/options', { params: { brand: sel.brand, model: v } })
      .then(({ data }) => setYears(data.years || []));
  };

  const search = () => {
    if (!sel.brand) return;
    const params = new URLSearchParams();
    params.set('vehicle_brand', sel.brand);
    if (sel.model) params.set('vehicle_model', sel.model);
    if (sel.year) params.set('vehicle_year', sel.year);
    nav(`/catalogo?${params.toString()}`);
  };

  return (
    <div
      data-testid="vehicle-finder"
      className={`bg-white ${compact ? 'border border-slate-200 p-4' : 'border-2 border-orange-500 p-5 shadow-sm'}`}
    >
      <div className="flex items-center gap-2 mb-3">
        <Car className="h-4 w-4 text-orange-600" />
        <h3 className="font-display font-bold text-slate-900 text-sm uppercase tracking-wider">
          Encuentra repuestos para tu vehículo
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-[1fr,1fr,1fr,auto] gap-2">
        <Select value={sel.brand} onValueChange={pickBrand}>
          <SelectTrigger data-testid="vf-brand" className="rounded-none">
            <SelectValue placeholder="Marca" />
          </SelectTrigger>
          <SelectContent>{brands.map((b) => <SelectItem key={b} value={b}>{b}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={sel.model} onValueChange={pickModel} disabled={!sel.brand}>
          <SelectTrigger data-testid="vf-model" className="rounded-none">
            <SelectValue placeholder="Modelo" />
          </SelectTrigger>
          <SelectContent>{models.map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}</SelectContent>
        </Select>
        <Select
          value={sel.year}
          onValueChange={(v) => setSel({ ...sel, year: v })}
          disabled={!sel.model}
        >
          <SelectTrigger data-testid="vf-year" className="rounded-none">
            <SelectValue placeholder="Año" />
          </SelectTrigger>
          <SelectContent className="max-h-64">
            {years.map((y) => <SelectItem key={y} value={String(y)}>{y}</SelectItem>)}
          </SelectContent>
        </Select>
        <Button
          data-testid="vf-search"
          onClick={search}
          disabled={!sel.brand}
          className="rounded-none bg-slate-900 hover:bg-slate-800 h-10 px-5 font-bold"
        >
          <Search className="h-4 w-4 mr-1" /> Buscar
        </Button>
      </div>
    </div>
  );
};
